import { MediumHeader } from "@narvar/nth-bit-header";
import Checkbox from "@narvar/nth-block-checkbox";
import { useTheme, withThemeProvider } from "@narvar/nth-hook-theme";
import TextInput, { SupportedInputType } from "@narvar/nth-block-text-input";
import React, { ChangeEvent, FC } from "react";

import { ReshopOptionsProps } from "./types";
import { useStyles } from "./ReshopOptInStyles";
import { Language } from "../components";
import { useLanguage } from "@narvar/nth-kit-returns-headless";

const ReshopOptIn: FC<ReshopOptionsProps> = ({ value, error, onChange }) => {
  const styles = useStyles();
  const {
    panelcontainerNoneNone,
    captiontextErrorNone,
    captiontextDefaultNone,
  } = useTheme();

  const { subscribe = false, phone = "" } = value ?? {};
  const phoneLabel = useLanguage({
    langKey: "returnsReviewReshopPhoneInputLabel",
  }).value;

  const handleSubscribeChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange?.({
      subscribe: event.target.checked,
      phone,
    });
  };
  const handlePhoneChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange?.({
      subscribe,
      phone: event.target.value,
    });
  };

  return (
    <div
      className={styles.wrapper}
      style={{
        borderRadius: panelcontainerNoneNone?.borderRadius ?? "4px",
        borderWidth: panelcontainerNoneNone?.borderWidth ?? "1px",
      }}>
      <MediumHeader>
        <Language langKey="returnsReviewReshopTitle" />
      </MediumHeader>

      <span>
        <Checkbox
          id="reshopSubscribeSmsUpdates"
          checked={subscribe}
          labelBoxCellStyle={{ background: "#fff" }}
          onChange={handleSubscribeChange}>
          <Language langKey="returnsReviewReshopCheckboxLabel" />
        </Checkbox>
      </span>
      {subscribe && (
        <div className={styles.formField}>
          <TextInput
            id="reshopCustomerPhone"
            type={SupportedInputType.tel}
            label={phoneLabel}
            animateLabel
            containerOverridesStyle={{ background: "#fff" }}
            error={!!error}
            value={phone}
            onChange={handlePhoneChange}
          />
          {error && (
            <div className={styles.errorMessage} style={captiontextErrorNone}>
              {error}
            </div>
          )}
        </div>
      )}
      <div className={styles.disclaimer} style={captiontextDefaultNone}>
        <Language langKey="returnsReviewReshopDisclaimer" />
      </div>
    </div>
  );
};

export default withThemeProvider(ReshopOptIn, {
  themeTokens: [
    "panelcontainerNoneNone",
    "captiontextErrorNone",
    "captiontextDefaultNone",
  ],
});
